// @flow
export { default } from './UserPostCard';



// WEBPACK FOOTER //
// ./src/components/user/UserPostCard/index.js